@if (job != null && job.wellInfo != null) {
  <div class="grid field col-12">
    <div class="grid field col-12">
      <!-- XO/EOT -->
      <div class="field col-12 md:col-1">
        <label>XO/EOT</label>
      </div>
      <div class="field col-12 md:col-1">
        <input type="text" pInputText class="w-full" placeholder="Enter Amount" [(ngModel)]="job.wellInfo.xoEot" (change)="setLateralLengthEst()"  [disabled]="disabled"/>
      </div>
      <!-- KOP -->
      <div class="field col-12 md:col-1">
        <label>KOP</label>
      </div>
      <div class="field col-12 md:col-1">
        <input type="text" pInputText class="w-full" placeholder="Enter Amount" [(ngModel)]="job.wellInfo.kop" (change)="setLateralLengthEst()"  [disabled]="disabled"/>
      </div>
      <!-- 30 Degree -->
      <div class="field col-12 md:col-1">
        <label>30 Degree</label>
      </div>
      <div class="field col-12 md:col-1">
        <input type="text" pInputText class="w-full" placeholder="Enter Amount" [(ngModel)]="job.wellInfo.thirtyDegree" (change)="setLateralLengthEst()" [disabled]="disabled" class="w-full" />
      </div>
      <!-- 60 Degree -->
      <div class="field col-12 md:col-1">
        <label>60 Degree</label>
      </div>
      <div class="field col-12 md:col-1">
        <input type="text" pInputText class="w-full" placeholder="Enter Amount" [(ngModel)]="job.wellInfo.sixtyDegree" (change)="setLateralLengthEst()" [disabled]="disabled"/>
      </div>
      <!-- 90 Degree (used be calleded TVD) -->
      <div class="field col-12 md:col-1">
        <label>90 Deg</label>
      </div>
      <div class="field col-12 md:col-1">
        <input type="text" pInputText class="w-full"placeholder="Enter Amount" [(ngModel)]="job.wellInfo.tvd" (change)="setLateralLengthEst()" [disabled]="disabled"/>
      </div>
      <!-- PBTD (Used to be called MD) -->
      <div class="field col-12 md:col-1">
        <label>PBTD</label>
      </div>
      <div class="field col-12 md:col-1">
        <input type="text" pInputText class="w-full" placeholder="Enter Amount" [(ngModel)]="job.wellInfo.md" (change)="setLateralLengthEst()" [disabled]="disabled"/>
      </div>
    </div>
    <div class="grid field col-12">
      <!--Lateral Length Est -->
      <div class="col-3">
        <label>Lateral Length Est.</label>
      </div>
      <div class="col-1">
        <label class="readOnly-label">{{job.wellInfo.lateralLengthEst}}</label>
      </div>
    </div>
    <div class="grid field col-12">
      <!-- String Type -->
      <div class="field col-12 md:col-1">
        <label>Workstring Type</label>
      </div>
      <div class="field col-12 md:col-3">
        <p-select [options]="stringTypes" [(ngModel)]="job.wellInfo.stringType" placeholder="Select String Type" [style]="{'width':'100%'}"  [disabled]="disabled"></p-select>
      </div>
      @if (job.wellInfo.stringType != 'Jointed Tubing') {
        <div class="field col-12 md:col-1">
          <label>Tubing OD (in)</label>
        </div>
      }
      @if (job.wellInfo.stringType == 'Jointed Tubing') {
        <div class="field col-12 md:col-1">
          <label>VIR Tubing OD</label>
        </div>
      }
      <div class="field col-12 md:col-3">
        <p-select [options]="ctwoTubingODs" [(ngModel)]="selectedCTWOTubingOD" (onChange)="setCTWOTubingOD()" placeholder="Select Size" [style]="{'width':'100%'}"  [disabled]="disabled"></p-select>
      </div>
      <!-- Coil Capacity -->
      <div class="field col-12 md:col-1">
        <label>Capacity (BBLS)</label>
      </div>
      <div class="field col-12 md:col-3">
        <p-inputNumber placeholder="Enter Amount" [(ngModel)]="job.wellInfo.coilCapacity" mode="decimal" [maxFractionDigits]="4" [disabled]="disabled"/>
      </div>
      <!-- CSG ID -->
      <!-- <div class="rl6">
      <label>CSG ID (in)</label>
    </div>
    <div class="rl6">
      <label class="readOnly-label">{{job.wellInfo.csgId}}</label>
    </div> -->
  </div>
  @if (job.wellInfo.stringType == 'Jointed Tubing') {
    <div class="grid field col-12">
      <div class="field col-12 md:col-1">
        <label>HOZ Tubing OD</label>
      </div>
      <div class="field col-12 md:col-3">
        <p-select [options]="hozTubingODs" [(ngModel)]="selectedHozTubingOD" (onChange)="setHozTubingOD()" placeholder="Select Size" [style]="{'width':'100%'}" [disabled]="disabled"></p-select>
      </div>
    </div>
  }
  <div class="grid field col-12">
    <div class="field col-12 md:col-1">
      <label># Plugs in Well</label>
    </div>
    <div class="field col-12 md:col-3">
      <!-- <input type="text" pInputText type="number" placeholder="Enter Amount" [(ngModel)]="job.wellInfo.fracPlugStages" [disabled]="disabled"/> -->
      <p-inputNumber placeholder="Enter Amount" [(ngModel)]="job.wellInfo.fracPlugStages" [disabled]="disabled"/>
    </div>
    <!--SITP Est -->
    <div class="field col-12 md:col-1">
      <label>SITP</label>
    </div>
    <div class="field col-12 md:col-3">
      <p-inputNumber placeholder="Enter Amount" [(ngModel)]="job.wellInfo.sitp" mode="decimal" [maxFractionDigits]="4" [disabled]="disabled"/>
    </div>
    <!--SICP Est -->
    <div class="field col-12 md:col-1">
      <label>SICP</label>
    </div>
    <div class="field col-12 md:col-3">
      <p-inputNumber placeholder="Enter Amount" [(ngModel)]="job.wellInfo.sicp" mode="decimal" [maxFractionDigits]="4" [disabled]="disabled"/>
    </div>
  </div>
  <p-fieldset legend="Production Casing/Tubing" [toggleable]="true" class="col-12" [collapsed]="true" >
    <app-casing-tubing [(ngModel)]="job.wellInfo.casingTubings" (csgIdChanged)="updateCsgId($event)" (casingOrTubingIdChanged)="validateIdSelected($event)" [disabled]="disabled"></app-casing-tubing>
  </p-fieldset>
  <p-fieldset legend="Plugs" class="col-12" [toggleable]="true" [collapsed]="true" >
    <app-plugs [(ngModel)]="job.wellInfo.plugSets" [disabled]="disabled"></app-plugs>
  </p-fieldset>
</div>
}

<p-dialog header="Casing Invalid" [(visible)]="showCasingInvalidDialog" [modal]="true" [style]="{width: '350px', minWidth: '200px'}" [baseZIndex]="10000" [dismissableMask]="true">
  <p>
    Selected Casing Outer Diameter must be larger than selected Tubing Outer Diameter.
  </p>
  <p-footer>
    <button type="button" pButton (click)="closeCasingInvalidDialog()">
      <i pButtonIcon class="pi pi-check"></i>
      <span pButtonLabel>Ok</span>
    </button>
  </p-footer>
</p-dialog>
